import * as React from "react";

/** X (formerly Twitter). Reproduced verbatim from the design handoff. */
export function XIcon(props: React.ComponentProps<"svg">) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
            <path d="M18.9 2.5h3.3l-7.2 8.2 8.5 11.3h-6.7l-5.2-6.9-6 6.9H2.3l7.7-8.8L1.9 2.5h6.8l4.7 6.3 5.5-6.3Zm-1.2 17.6h1.8L7.4 4.3H5.4l12.3 15.8Z" />
        </svg>
    );
}
